import { isAdditionalKycForm } from './isAdditionalKycForm'
import { useEffect, useState } from 'react'

import { FiatFormScreen, type FiatFormScreenProps } from './FiatFormScreen'
import { FiatKycIntroScreen } from './FiatKycIntroScreen'
import { sectionPages, unsupportedFields } from './formLayout'
import { type KycWalk, walkRound } from './kycFormPosition'
import { logger } from '../logging/logger'

export function FiatIdentityStep(props: FiatFormScreenProps) {
  // Held here, above the round: a later round's dots carry on from where the
  // earlier rounds' left off, whichever consent it re-keys to.
  const [walk, setWalk] = useState<KycWalk>()
  const walked = walkRound(
    walk,
    props.form.formId,
    sectionPages(props.form.fields).length,
  )
  if (walked !== walk) {
    setWalk(walked)
  }
  return (
    <IdentityRound
      key={isAdditionalKycForm(props.form) ? 'additional' : 'identity'}
      {...props}
      walk={walked}
    />
  )
}

function IdentityRound(props: FiatFormScreenProps) {
  const [step, setStep] = useState<'consent' | 'form'>('consent')
  const additionalInformation = isAdditionalKycForm(props.form)
  // The classification picks which consent wording the user agrees to, so the
  // field ids behind it belong in the record.
  useEffect(() => {
    logger.info('connect-rn:fiat:kyc_round_classified', {
      formId: props.form.formId,
      additionalInformation,
      fieldIds: props.form.fields.map((field) => field.id),
    })
  }, [props.form.formId, additionalInformation])
  // Do not ask for consent to a form this build cannot display.
  const supported =
    unsupportedFields(props.form.fields).length === 0 &&
    sectionPages(props.form.fields).length > 0
  if (supported && step === 'consent') {
    return (
      <FiatKycIntroScreen
        provider={props.provider}
        additionalInformation={additionalInformation}
        onContinue={() => setStep('form')}
        onCancel={props.onClose}
      />
    )
  }
  return (
    <FiatFormScreen
      {...props}
      onClose={() => {
        if (!supported) {
          props.onClose()
          return
        }
        setStep('consent')
      }}
    />
  )
}
